module.exports = __webpack_public_path__ + "static/blog-03-1f7d86f4f2a6dce2405257d4558cdb37.jpg";